// Action types
export const ActionTypes = {
  SET_PLATE_VALUE: "SET_PLATE_VALUE",
};

export const setPlateValue = (data) => ({
  type: ActionTypes.SET_PLATE_VALUE,
  payload: data,
});
